import React, { useState } from 'react';
import './CSS/LoginSignup.css';

const LoginSignup = () => {
  const [state, setState] = useState("Login");
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    email: ""
  });

  const changeHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const login = async () => {
    console.log("Login Function Executed", formData);

    try {
      const response = await fetch('http://localhost:4000/login', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: formData.email,
          password: formData.password
        }),
      });

      const responseData = await response.json();

      if (response.ok && responseData.success) {
        localStorage.setItem('auth-token', responseData.token);
        // استرداد الاسم من الاستجابة أو استخدام البريد كبديل مؤقت
        const userName = responseData.user?.name || formData.email.split('@')[0];
        localStorage.setItem('user-name', userName);
        window.location.replace("/");
      } else {
        alert(responseData.errors || "Login failed.");
      }

    } catch (error) {
      console.error("Error during login:", error);
      alert("Login error. Please try again.");
    }
  };

  const signup = async () => {
    console.log("Sign Up Function Executed", formData);

    try {
      const response = await fetch('http://localhost:4000/signup', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const responseData = await response.json();
      console.log("Response from server:", responseData);

      if (response.ok && responseData.success) {
        localStorage.setItem('auth-token', responseData.token);
        localStorage.setItem('user-name', formData.username);
        window.location.replace("/");
      } else {
        alert(responseData.errors || "Signup failed.");
      }
    } catch (error) {
      console.error("Error during signup:", error);
      alert("Signup error. Please try again.");
    }
  };

  return (
    <div className='loginsignup'>
      <div className="loginsignup-container">
        <h1>{state}</h1>
        <div className="loginsignup-fields">
          {state === "Sign Up" && (
            <input
              name='username'
              value={formData.username}
              onChange={changeHandler}
              type="text"
              placeholder="Your Name"
            />
          )}
          <input
            name='email'
            value={formData.email}
            onChange={changeHandler}
            type="email"
            placeholder="Email Address"
          />
          <input
            name='password'
            value={formData.password}
            onChange={changeHandler}
            type="password"
            placeholder="Password"
          />
        </div>
        <button onClick={() => {
          state === "Login" ? login() : signup();
        }}>
          Continue
        </button>

        {state === "Sign Up" ? (
          <p className="loginsignup-login">
            Already have an account? <span onClick={() => setState("Login")}>Login Here</span>
          </p>
        ) : (
          <p className="loginsignup-login">
            Create an account? <span onClick={() => setState("Sign Up")}>Click Here</span>
          </p>
        )}

      </div>
    </div>
  );
};

export default LoginSignup;